import { FormValidator } from "assets/js/validation";
import * as Alerts from "assets/js/alerts";

const Validator = new FormValidator(LoginForm);
const ErrorAlert = new Alerts.ErrorAlert(LoginForm);

//remove specific parameters from the querystring
const url = new URL(window.location.href);
url.searchParams.delete('return');
url.searchParams.delete('reset');
history.replaceState({}, '', url);


LoginForm.onsubmit = login;

async function login(e) {
	e.preventDefault();
	Login.disabled = true;
	Spinner.classList.remove('d-none');

	//client-side validation
	if (!await Validator.valid()) {
		Login.disabled = false;
		Spinner.classList.add('d-none');
		return;
	}

	//submit form to server
	const options = {
		method: 'POST',
		body: new FormData(LoginForm)
	};

	fetch(LoginForm.action, options)
		.then(async response => {

			const data = await response.json();
			switch (response.status) {
				case 200:
					//user successfully logged in
					if (data.url) {
						window.location.href = data.url;
					} else {
						window.location.href = '/';
					}
					break;

				default:
					//server-side errors
					ErrorAlert.show(data);
					break;
			}

			Login.disabled = false;
			Spinner.classList.add('d-none');
		});
}
